// App.js
import { BrowserRouter as Router, Routes, Route, useParams, useNavigate } from "react-router-dom";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import { JobsPage } from "./pages/JobsPage";
import { ApplyForm } from "./pages/ApplyForm";
import jobsData from "./data/jobs.json"; // your jobs JSON

// Wrapper to pass job info to ApplyForm
const ApplyFormWrapper = () => {
  const { jobId } = useParams();
  const job = jobsData.find((j) => j.id === parseInt(jobId));
  return <ApplyForm job={job} />;
};

// Job Detail Page
const JobDetailPage = () => {
  const { jobId } = useParams();
  const navigate = useNavigate();
  const job = jobsData.find((j) => j.id === parseInt(jobId));

  if (!job) return <p>Job not found.</p>;

  return (
    <div className="jobs-page">
      <h1>{job.title}</h1>
      <div className="job-card expanded">
        <div className="company">{job.company}</div>
        <p>{job.description}</p>

        <div className="job-section">
          <h4>Responsibilities</h4>
          <ul>{job.responsibilities.map((r, i) => <li key={i}>{r}</li>)}</ul>
        </div>

        <div className="job-section">
          <h4>Requirements</h4>
          <ul>{job.requirements.map((r, i) => <li key={i}>{r}</li>)}</ul>
        </div>

        <div className="job-section">
          <h4>Offer</h4>
          <ul>{job.offer.map((o, i) => <li key={i}>{o}</li>)}</ul>
        </div>

        <p><strong>Location:</strong> {job.location}</p>
        <p><strong>Type:</strong> {job.type}</p>
        <p><strong>Income Potential:</strong> {job.income_potential}</p>

        <button className="apply-btn" onClick={() => navigate(`/apply/${job.id}`)}>
          Apply Now
        </button>
      </div>
    </div>
  );
};
const Layout = ({ children }) => (
  <div className="layout">
    <Header style={{ gridArea: "header" }} />
    <main style={{ gridArea: "main" }}>{children}</main>
    <Footer style={{ gridArea: "footer" }} />
  </div>
);

export const App = () => (
  <Router>
     <Layout>
    <Routes>
      <Route path="/" element={<JobsPage />} />
      <Route path="/jobs/:jobId" element={<JobDetailPage />} />
      <Route path="/apply/:jobId" element={<ApplyFormWrapper />} />
    </Routes>
    </Layout>
  </Router>
);
